'use client'

import { themeBackgroundMap, themeBorderColorMap } from '@mntn-dev/ui-theme'
import { themeBackgroundBlurMap } from '@mntn-dev/ui-theme'
import { cn } from '@mntn-dev/ui-utilities'
import type { PropsWithChildren } from 'react'
import { BladeCommon, type BladeCommonProps } from '../blade-common.tsx'

type EnhancementBladeProps = PropsWithChildren<
  BladeCommonProps & {
    isSelected?: boolean
    isSelectable?: boolean
  }
>

export const EnhancementBlade = ({
  children,
  className,
  isSelected,
  isSelectable,
  ...props
}: EnhancementBladeProps) => {
  return (
    <BladeCommon
      className={cn(
        `rounded-lg gap-6 before:${themeBackgroundBlurMap['blur-md']}`,
        themeBackgroundMap['container-secondary'],
        isSelectable && 'border',
        {
          [`${themeBorderColorMap.transparent} hover:shadow-glow-blue-lg`]:
            isSelectable && !isSelected,
          [`${themeBorderColorMap.info} shadow-glow-blue-lg`]:
            isSelectable && isSelected,
        },
        className
      )}
      {...props}
    >
      {children}
    </BladeCommon>
  )
}
